<template>
	<div class="deliverable-listing social-media" :class="{hasFilter: (filterQuery.status.length || filterQuery.coordinator.length || filterQuery.tag.length || filterQuery.outlet.length)}">

		<b-modal size="lg" hide-footer id="editSocialModal" title="Edit Social Deliverable" class="modal-edit-social-deliverable" @hide="editSocialModalHidden" @shown="pushRoute" @hidden="removeRoute">
			<EditSocialModal :allContacts="allContacts"  ref="refEditSocialModal" :namespace="namespace"  :tabIndex="tabIndex"/>
		</b-modal>

		<b-modal id="deleteDeliverableConfirmModal" type="warn" title="Confirm Deletion" @ok="onConfirmRemoveDeliverable" @cancel="onCancelRemoveDeliverable" ok-title="Yes, Delete">
			<p>Are you sure you want to delete this deliverable?</p>
		</b-modal>

		<b-modal size="lg" hide-footer id="editSocialCampaignModal" title="Edit Social Campaign" class="modal-edit-social-campaign">
			<SocialCampaignDialog ref="refSocialCampaignDialogModal" @socialCampaignClose="createCampaignClose" :namespace="namespace"/>
		</b-modal>


		<div class="deliverable-header">
			<HeaderIcon
				:totalDeliverableCount="this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0"
				:totalOutletCount="this.outletCount ? this.outletCount : 0"
				:myWeek="myWeek"
			/>
		</div>

		<SocialTabs/>
		
		<div class="deliverable-block-wrap">

			<div class="group-by-wrap dropdown">
				<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">List by <i class="fas text-primary float-right fa-chevron-down fa-fw"></i></button>
				<div class="dropdown-menu">
					<router-link class="dropdown-item" :to="{ name: 'socialMedia', params: { filterQuery: deliverableFilter, socialGroupBy: 'socialMedia' } }">Dates</router-link>
					<router-link class="dropdown-item" :to="{ name: 'socialMediaGrouped', params: { filterQuery: deliverableFilter, socialGroupBy: 'socialMediaGrouped' } }">Campaign/Series</router-link>
				</div>
			</div>
		
			<HorizontalMonthPicker/>			

			<div class="deliverable-block">
				<div class="delv-block-resp">
					<div class="d-flex flex-row dbox-wrapper">
						<div class="dbox-left-side dleft-inner-wrap">
							
							<div class="top-row social list-labels">
								<div class="data-items social-name">
									<span>Post Name</span>
								</div>
								<div class="data-items social-people">
									<span>People</span>
								</div>
								<div class="data-items social-date">
									<span>Posting Date</span>
								</div>
								<div class="data-items social-thumbnail">
									<span>Image</span>
								</div>
								<div class="data-items social-caption">
									<span>Post Copy</span>
								</div>
								<div class="data-items social-platforms">
									<span>Platforms</span>
								</div>
								<div class="data-items social-languages">
									<span>EN/FR</span>
								</div>
								<div class="data-items social-status">
									<span>Status</span>
								</div>
							</div>

							<div class="row listing-row"
								v-for="(deliverable, index) in deliverablesArray"
								v-if="index!='totalOutlets'"
								:key="'deliverable'+index">
								<div class="col titles breakpoint__fix" :style="infoColStyle(deliverable)">
									<div
										:class="`deliverable-title edit-d-title`"
										@click="showModalFn(deliverable.id)"
									>
										{{ deliverable.title }}&nbsp;
									</div>
									<div class="mobile-task-expand-button-area">
										<div class="mobile-task-exp-btn">
											<CollapseTaskBtn :deliverable="deliverable" :index="index" :expandAll="expandAll" />
										</div>
									</div>
									<div v-b-tooltip.hover title="Delete" v-if="userCanEditDeliverable()" @click.stop="deleteDeliverableClick(deliverable)" :class="`delete-bar ${deliverable.id == stripRemoveDeliverableId ? 'hovered' : ''}`" v-click-outside="deleteDeliverableClickOutside(deliverable.id)">
										<span><i class="fas fa-trash"></i></span>
									</div>
								</div>
								<!-- Hard code these like projects, the modal is hard coded anyway -->
								<div 
									v-if="!isMobile()" 
									v-for="(field, index) in _.filter(deliverable.customFields, {field_key: 'user'})" :key="''+deliverable.id+field.field_id"
									class="col infos"> 
									<SocialCustomFields :customField="field" :deliverable="deliverable"/>
								</div>
								<div 
									v-if="!isMobile()" 
									v-for="(field, index) in _.filter(deliverable.customFields, {field_key: 'post_date'})" :key="''+deliverable.id+field.field_id"
									class="col infos"> 
									<SocialCustomFields :customField="field" :deliverable="deliverable"/>
								</div>
								<div class="col infos">
									<span>Image</span>
								</div>
								<div class="col infos">
									<span>Post Copy</span>
								</div>
								<div class="col infos">
									<span>Platforms</span>
								</div>
								<div class="col infos">
									<span>Languages</span>
								</div>
								<div 
									v-if="!isMobile()" 
									v-for="(field, index) in _.filter(deliverable.customFields, {field_key: 'social_status'})" :key="''+deliverable.id+field.field_id"
									class="col infos"> 
									<SocialCustomFields :customField="field" :deliverable="deliverable"/>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="new-social-group-container dropright">
				<button type="button" class="btn btn-theme header-filter-btns" data-toggle="dropdown">New <i class="fas text-primary float-right fa-plus fa-fw"></i></button>
				<div class="dropdown-menu">
					<a class="dropdown-item" href="#" @click="createCampaignClick">Campaign</a>
					<a class="dropdown-item" href="#" @click="createSeriesClick">Series</a>
				</div>
				<!-- <SocialCampaignDialog v-if="isCreateCampaignOpen" @socialCampaignClose="createCampaignClose" :namespace="namespace"/> -->
			</div>

			<div class="pagination-wrapper" v-show="!myWeek">
				<pagination :data="allDeliverablesPaginationData" @pagination-change-page="onChangePage" :limit="isMobile() ? 3 : 5" :size="isMobile() ? 'small' : 'default'"></pagination>
			</div>

		</div>

	</div>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations } from "vuex";
import EditSocialModal from "./EditSocialModal";
import TaskFields from "./TaskFields";
import TaskFieldLabels from "./TaskFieldLabels";
import CreateContactModal from "./CreateContactModal";
import UpdateContactModal from "./EditContactModal";
import ViewTitleModal from "../common/ViewTitleModal";
import UpdateSpokespersonModal from "./EditSpokespersonModal";
import CreateSpokespersonModal from "./CreateSpokespersonModal";
import vueStarRate from "vue-js-star-rating";

import DuplicateMediaCallBtn from "../common/DuplicateMediaCallBtn";
import DeliverableStatusOverview from './DeliverableStatusOverview';
// import DeliverablePriorityBadge from "../common/DeliverablePriorityBadge";

import UpdateWhoModal from "./EditWhoModal";
import CreateWhoModal from "./CreateWhoModal";


import DeliverableListTags from "./DeliverableListTags";
import DeliverableProjects from "./DeliverableProjects";
import DeliverableDepartments from "./DeliverableDepartments";
import DeliverableListContacts from "./DeliverableListContacts";
import DeliverableListCoordinators from "./DeliverableListCoordinators";
import TaskCompletionGraph from "./TaskCompletionGraph";
import CollapseTaskBtn from "./CollapseTaskBtn";
import DeliverableTypeIcon from './DeliverableTypeIcon';
import DeliverableDatesRibbon from "./DeliverableDatesRibbon";
import SocialCustomFields from '../common/SocialCustomField';
import HeaderIcon from './HeaderIcon';
import toast from '../../toast';
import SocialCampaignDialog from "./SocialCampaignDialog.vue";

import HorizontalMonthPicker from '../common/HorizontalMonthPicker';
import SocialTabs from "../common/SocialTabs";

export default {
	props: ["myWeek", "filterQuery", "expandAll"],
	data() {
		return {
			tabIndex:0,
			activeView: '-1',
			showUpdateView: false,
			viewBtnLabel: 'Views',
			currentViewData: {},
			currentFilterData: false,
			showUpdateViewText: false,
			showCreateNewView: false,
			viewId: '',

			viewModalShowCreateView: false,
			viewModalShowUpdateView: false,

			showNewViewTitleArea: false,
			showUpdateViewTitleArea: false,

			showRemoveDeliverableId: null,
			stripRemoveDeliverableId: null,

			isCreateCampaignOpen: false,
		}
	},
	created() {
		this.fetchDeliverables();
		// this.fetchContacts();
		this.fetchDepartments();
		this.fetchActiveDepartments();
		this.fetchProjects();
		this.fetchViews();
		// this.fetchSubjects();
		this.fetchTags();
		this.fetchUsers();
		this.fetchActiveUsers();
		this.fetchGeoData();
		this.fetchAllCustomFields();
	},
	components: {
		EditSocialModal,
		TaskFields,
		TaskFieldLabels,
		DeliverableListContacts,
		CreateContactModal,
		UpdateContactModal,
		UpdateSpokespersonModal,
		CreateSpokespersonModal,
		UpdateWhoModal,
		CreateWhoModal,
		DeliverableListTags,
		DeliverableListCoordinators,
		TaskCompletionGraph,
		CollapseTaskBtn,
		DuplicateMediaCallBtn,
		DeliverableDatesRibbon,
		DeliverableDepartments,
		ViewTitleModal,
		vueStarRate,
		DeliverableProjects,
		DeliverableTypeIcon,
		DeliverableStatusOverview,
		SocialCustomFields,
		HeaderIcon,
		HorizontalMonthPicker,
		SocialTabs,
		SocialCampaignDialog
	},
	computed: {
		...mapGetters([
			"systemSettings",
			"userAbilities",
		]),
		...mapState({
		  state (state) {
		    return state[this.namespace]
		  },
		  allDeliverables (state, getters) {
		    return getters[this.namespace + 'allDeliverables']
		  },
		  allDeliverablesPaginationData (state, getters) {
		    return getters[this.namespace + 'allDeliverablesPaginationData']
		  },
		  userDeliverablesPaginationData (state, getters) {
		    return getters[this.namespace + 'userDeliverablesPaginationData']
		  },
		  allTags (state, getters) {
		    return getters[this.namespace + 'allTags']
		  },
		  allContacts (state, getters) {
		    return getters[this.namespace + 'allContacts']
		  },
		  deliverableDetail (state, getters) {
		    return getters[this.namespace + 'deliverableDetail']
		  },
		  allDepartments (state, getters) {
		    return getters[this.namespace + 'allDepartments']
		  },
		  userDeliverables (state, getters) {
		    return getters[this.namespace + 'userDeliverables']
		  },
		  unGroupedUserDeliverables (state, getters) {
		    return getters[this.namespace + 'unGroupedUserDeliverables']
		  },
		  deliverableFilter (state, getters) {
		    return getters[this.namespace + 'deliverableFilter']
		  },
		  myWeekDeliverableFilter (state, getters) {
		    return getters[this.namespace + 'myWeekDeliverableFilter']
		  },
		  userViews (state, getters) {
		    return getters[this.namespace + 'userViews']
		  },
		  deliverableTypes (state, getters) {
		    return getters[this.namespace + 'deliverableTypes']
		  },
		  userManageProjects (state, getters) {
		    return getters[this.namespace + 'userManageProjects']
		  },
		  deliverableCount (state, getters) {
		    return getters[this.namespace + 'deliverableCount']
		  },
		  editSocialModal (state, getters) {
		    return getters[this.namespace + 'editSocialModal']
		  },
		  addContactModal (state, getters) {
		    return getters[this.namespace + 'addContactModal']
		  },
		  editContactModal (state, getters) {
		    return getters[this.namespace + 'editContactModal']
		  },
		  editSpokespersonModal (state, getters) {
		    return getters[this.namespace + 'editSpokespersonModal']
		  },
		  editWhoModal (state, getters) {
		    return getters[this.namespace + 'editWhoModal']
		  },
			getDeliverableTemplateSlug(state, getters) {
				return getters[this.namespace + "getDeliverableTemplateSlug"];
			},

		}),
		deliverableListIcon() {
			if(this.deliverableFilter.deliverableType && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') {
				if(typeof this.deliverableFilter.deliverableType.id != 'undefined' && this.deliverableFilter.deliverableType.id != 'all') {
					if (this.deliverableFilter.deliverableType.slug) {
						return this.deliverableFilter.deliverableType.slug;
					}
					return this.deliverableFilter.deliverableType.id.replaceAll('_', '-');
				} else {
					return 'media-call';
				}
			} else {
				return 'media-call';
			}
		},
		deliverablesArray() {
			if(this.myWeek) {
				return this.userDeliverables
			} else {
				return this.allDeliverables;
			}
		},
		_() {
			return _;
		},


		// Hardcode
		presetViewsMyWeek() {
			return [
				{
					id: 'p1',
					createdTime: null,
					title: "Today",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p2',
					createdTime: null,
					title: "This Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().startOf('week').toISOString()}","endDate":"${this.$moment().endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p3',
					createdTime: null,
					title: "Next Week",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().add(1, 'week').startOf('week').toISOString()}","endDate":"${this.$moment().add(1, 'week').endOf('week').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p4',
					createdTime: null,
					title: "No Deadline",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"${this.$moment().toISOString()}","endDate":"${this.$moment().toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"filterNoTaskDueDate":true,"noDepartment":"not_accepted","noCoordinator":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
				{
					id: 'p5',
					createdTime: null,
					title: "Overdue",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByTaskDate":true,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"taskDateRange":{"startDate":"","endDate":"${this.$moment().add(-1, 'day').toISOString()}"},"dateCreatedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"dateCompletedRange":{"startDate":"2021-12-06T20:17:24.942Z","endDate":"2021-12-06T20:17:24.942Z"},"status":[],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":true,"filterNoDueDate":false,"noDepartment":"not_accepted","noCoordinator":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]
		},
		presetViewsDashboard() {
			const filterForMyWeek = this.presetViewsMyWeek;
			const filterForDashboard =
			[
				{
					id: 'p101',
					createdTime: null,
					title: "Open Deliverables",
					saved_data: `{"query":null,"sort":"","priorityFilter":0,"outletCompany":[],"filterByDate":false,"filterByDateCreated":false,"filterByDateCompleted":false,"dateRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCreatedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"dateCompletedRange":{"startDate":"2021-12-08T22:56:27.660Z","endDate":"2021-12-08T22:56:27.660Z"},"status":[{"name":"Pending Completion","color":"var(--wf-pending-completion)"},{"name":"Not Started","color":"var(--wf-not-started)"},{"name":"In Progress","color":"var(--wf-in-progress)"},{"name":"Awaiting Approval","color":"var(--wf-awaiting-approval)"}],"outlet":[],"deliverableType":[],"tag":[],"department":[],"coordinator":[],"project":[],"noDeparment":"not_accepted","noOutlet":"not_accepted","myWeek":false,"filterNoDueDate":false,"noDepartment":"not_accepted"}`,
					user_id: localStorage.getItem("userId"),
					preset: true,
				},
			]

			return filterForDashboard.concat(filterForMyWeek);
		},

		userViewsDeliverable() {
			return _.filter(this.userViews, {view_type: "deliverable"});
		},
 	},
	methods: {
		...mapActions({
		  fetchDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDeliverables', payload)
		  },
		  createTag (dispatch, payload) {
		    return dispatch(this.namespace + 'createTag', payload)
		  },
		  fetchUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUsers', payload)
		  },
		  fetchActiveUsers (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveUsers', payload)
		  },
		  fetchContacts (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchContacts', payload)
		  },
		  updateFieldValue (dispatch, payload) {
		    return dispatch(this.namespace + 'updateFieldValue', payload)
		  },
		  fetchDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchDepartments', payload)
		  },
		  fetchActiveDepartments (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchActiveDepartments', payload)
		  },
		  fetchSubjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchSubjects', payload)
		  },
		  fetchTags (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchTags', payload)
		  },
		  fetchGeoData (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchGeoData', payload)
		  },
		  fetchAllCustomFields (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchAllCustomFields', payload)
		  },
		  filterDeliverables (dispatch, payload) {
		    return dispatch(this.namespace + 'filterDeliverables', payload)
		  },
		  fetchViews (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchViews', payload)
		  },
		  fetchProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchProjects', payload)
		  },
		  getDeliverableTypes (dispatch, payload) {
		    return dispatch(this.namespace + 'getDeliverableTypes', payload)
		  },
		  fetchUserManageProjects (dispatch, payload) {
		    return dispatch(this.namespace + 'fetchUserManageProjects', payload)
		  },
		  updateSocialMediaPostUrl (dispatch, payload) {
		    return dispatch(this.namespace + 'updateSocialMediaPostUrl', payload)
		  },
		  createSocialSeries (dispatch, payload) {
		    return dispatch(this.namespace + 'createSocialSeries', payload)
		  },
		  createSocialCampaign (dispatch, payload) {
		    return dispatch(this.namespace + 'createSocialCampaign', payload)
		  },
		}),
		...mapMutations({
		  setDataLoading (commit, payload) {
		    return commit(this.namespace + 'setDataLoading', payload)
		  },
		}),
		getDeliverablePageTitle() {
			let returnData = '';
			let totalOutletCount = this.outletCount ? this.outletCount : 0;
			let totalDeliverableCount = this.allDeliverablesPaginationData.total ? this.allDeliverablesPaginationData.total : 0;
			if(typeof this.deliverableFilter.deliverableType == 'undefined') {
				return 'Deliverables'  + '<span class="text-muted">('+totalDeliverableCount+' deliverables, '+totalOutletCount+' calls)</span>'
			}
			if((typeof this.deliverableFilter.deliverableType.name != 'undefined' && typeof(this.deliverableFilter.deliverableType[0]) == 'undefined') && this.deliverableFilter.deliverableType.name != 'All') {
				returnData = this.deliverableFilter.deliverableType.name;
			} else {
				returnData = 'Deliverables';
			}
			return returnData + '<span class="text-muted">('+totalDeliverableCount+' deliverables, '+totalOutletCount+' calls)</span>';
		},

		handleResetFilter() {
			$('.viewmenu-dropdown').removeClass('show');
			this.$root.$emit('resetFilter')
		},
		updatePerfectScroll() {
			let self = this;
			setTimeout(function() {
				if(typeof self.$refs.views__scroll != 'undefined') {
					self.$refs.views__scroll.update();
				}
			}, 1);
		},
		setActiveView() {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(localStorage.getItem('dashboardActiveSave')) {
					this.activeView = localStorage.getItem('dashboardActiveSave');
					this.viewBtnLabel = localStorage.getItem('dashboardActiveSaveTitle');
					this.currentViewData = localStorage.getItem('dashboardActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(localStorage.getItem('myWeekActiveSave')) {
					this.activeView = localStorage.getItem('myWeekActiveSave');
					this.viewBtnLabel = localStorage.getItem('myWeekActiveSaveTitle');
					this.currentViewData = localStorage.getItem('myWeekActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				if(localStorage.getItem('mediaCallActiveSave')) {
					this.activeView = localStorage.getItem('mediaCallActiveSave');
					this.viewBtnLabel = localStorage.getItem('mediaCallActiveSaveTitle');
					this.currentViewData = localStorage.getItem('mediaCallActiveSaveData');
					if (!this.activeView.startsWith('p')) this.showUpdateView = true;
				} else {
					this.activeView =  '-1';
					this.viewBtnLabel = 'Views';
					this.showUpdateViewText = false;
				}
			}

			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		removeView(viewId) {
			if(this.$router.currentRoute.name == 'dashboard') {
				if(viewId == localStorage.getItem('dashboardActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'myWeek') {
				if(viewId == localStorage.getItem('myWeekActiveSave')) {
					this.resetView();
				}
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				if(viewId == localStorage.getItem('mediaCallActiveSave')) {
					this.resetView();
				}
			}
			this.$store.dispatch(this.namespace + 'removeView', viewId);
		},
		resetView() {
			localStorage.removeItem("dashboardActiveSave");
			localStorage.removeItem("myWeekActiveSave");
			localStorage.removeItem("dashboardActiveSaveTitle");
			localStorage.removeItem("myWeekActiveSaveTitle");
			localStorage.removeItem("mediaCallActiveSave");
			localStorage.removeItem("mediaCallActiveSaveTitle");
			this.setActiveView();
		},
		loadView(viewData) {
			this.currentViewData = JSON.parse(viewData.saved_data);
			let index = viewData.id;
			this.showUpdateView = true;
			this.viewBtnLabel = viewData.title;
			if(this.$router.currentRoute.name == 'dashboard') {
				this.activeView = index;
				localStorage.setItem('dashboardActiveSave', index);
				localStorage.setItem('dashboardActiveSaveTitle', viewData.title);
				localStorage.setItem('dashboardActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.activeView = index;
				localStorage.setItem('myWeekActiveSave', index);
				localStorage.setItem('myWeekActiveSaveTitle', viewData.title);
				localStorage.setItem('myWeekActiveSaveData', viewData.saved_data);
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				this.activeView = index;
				localStorage.setItem('mediaCallActiveSave', index);
				localStorage.setItem('mediaCallActiveSaveTitle', viewData.title);
				localStorage.setItem('mediaCallActiveSaveData', viewData.saved_data);
			}
			if(this.$router.currentRoute.name == 'dashboard') {
				this.$store.commit(this.namespace + 'setDashboardDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.deliverableFilter);
				// this.filterQuery = this.deliverableFilter;
			} else if(this.$router.currentRoute.name == 'myWeek') {
				this.$store.commit(this.namespace + 'setMyWeekDeliverableFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.myWeekDeliverableFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			} else if(this.$router.currentRoute.name == 'mediaCallPage') {
				this.$store.commit(this.namespace + 'setMediaCallFilter', viewData.saved_data);
				this.$root.$emit('setSaveView', this.mediaCallFilter);
				// this.filterQuery = this.myWeekDeliverableFilter;
			}
		},
		loadViewFromModal(viewData) {
			this.loadView(viewData);
			this.$bvModal.hide("headerViewSelectModal");
		},
		saveView() {
			this.$bvModal.show("viewTitleModal");
		},
		modalSaveView() {
			this.showNewViewTitleArea = true;
		},
		directUpdateView() {
			this.showUpdateViewText = false;
			let view = "";
			if (this.$router.currentRoute.name == "dashboard") {
				view = this.deliverableFilter;
			} else if (this.$router.currentRoute.name == "myWeek") {
				view = this.myWeekDeliverableFilter;
			} else if (this.$router.currentRoute.name == "mediaCallPage") {
				view = this.mediaCallFilter;
			}
			let viewData = {
					title: this.viewBtnLabel,
					filterQuery: view,
					viewId: this.activeView
				};
			let that = this;
			this.$store.dispatch(this.namespace + "saveView", viewData).then(function() {
				if(that.$router.currentRoute.name == 'dashboard') {
					localStorage.setItem('dashboardActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'myWeek') {
					localStorage.setItem('myWeekActiveSaveData', JSON.stringify(view));
				} else if(that.$router.currentRoute.name == 'mediaCallPage') {
					localStorage.setItem('mediaCallActiveSaveData', JSON.stringify(view));
				}
				that.setActiveView();
				toast.info('View has been saved.');
			});
		},
		updateView() {
			this.$bvModal.show("viewTitleUpdateModal");
		},
		modalUpdateView() {
			this.showUpdateViewTitleArea = true;
		},
		viewSelectModalHidden() {
			this.showNewViewTitleArea = false;
			this.showUpdateViewTitleArea = false;
		},
		setPriority(deliverable, isMobile) {
			let priority;
			if (isMobile) {
				priority = $('.mobile-deli-info .listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			} else {
				priority = $('.data-items.hide-mobile .listing-priority-del-'+deliverable.id+' .vue-star-rate ul.list li.active').length;
			}
			console.log(priority);
			let priorityData = {
				field_id: 23,
				parentId: null,
				value: priority,
				deliverable_id: deliverable.id,
				id: deliverable.id
			};
			this.updateFieldValue(priorityData);
		},
		editSocialModalHidden() {
			this.$store.commit(this.namespace + 'setDeliverable', this.deliverableDetail)
		},
		hasMyWeek() {
			if (this.userDeliverables) {
				if (this.userDeliverables.overdue.length > 0 ||
				this.userDeliverables.today.length > 0 ||
				this.userDeliverables.thisWeek.length > 0 ||
				this.userDeliverables.nextWeek.length > 0 ||
				this.userDeliverables.upcoming.length > 0 ||
				this.userDeliverables.noDeadline.length > 0
				// || this.userDeliverables.completed.length > 0
				) {
					return true;
				}
			}
			return false;
		}
		,
		createNewDeliverable() {
			// Hard coded
			let type = 'social_media';
			this.$store
				.dispatch(this.namespace + "createNewDeliverable", { type })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editSocialModal");
					this.$nextTick(() => {
						$('.edit-social-deliverable-modal .deliverable-title').trigger('click');
					})
					this.$store.dispatch(this.namespace + "fetchDeliverables")
					this.fetchDeliverableCount();
				});
		},
		focusContactModal() {
			this.$refs.refContactModal.focusMyElement();
		},
		focusUpdateContactModal() {
			this.$refs.refUpdateContactModal.focusMyElement();
		},
		focusSpokespersonModal() {
			this.$refs.refSpokespersonModal.focusMyElement();
		},
		focusUpdateSpokespersonModal() {
			this.$refs.refUpdateSpokespersonModal.focusMyElement();
		},
		focusWhoModal() {
			this.$refs.refWhoModal.focusMyElement();
		},
		focusUpdateWhoModal() {
			this.$refs.refUpdateWhoModal.focusMyElement();
		},
		onChangePage(data) {
			this.setDataLoading(true);
			this.fetchDeliverableCount();
			this.fetchDeliverables(data).then(() => {
				this.setDataLoading(false);
			});
		},

		showModalFn(deliverableId) {
			// shows edit deliverable modal
			this.$store
				.dispatch(this.namespace + "getDeliverableDetail", { deliverableId })
				.then(() => {
					let currentTitle = document.title.match(/\(\d+\)\s/g);
					if(!currentTitle) {
						document.title = this.deliverableDetail.title;
					} else {
						document.title = currentTitle[0] + this.deliverableDetail.title;
					}
					this.$bvModal.show("editSocialModal");
				});
		},

		/*pushRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') == -1) {
				history.pushState(
					{},
					null,
					'deliverable/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},*/
		pushRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') == -1) {
				history.pushState(
					{},
					null,
					'social-media/' + encodeURIComponent(this.deliverableDetail.id) + '/' + encodeURIComponent(this.deliverableDetail.slug)
				)
			}
		},
		/*
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('deliverable/') != -1) {
				this.$router.push({name: 'dashboard'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},*/
		removeRoute() {
			if(this.$router.currentRoute.path.indexOf('social-media/') != -1) {
				this.$router.push({name: 'socialMedia'});
			} else {
				history.pushState(
					{},
					null,
					this.$router.currentRoute.path
				);
				//this.$router.push(this.$router.currentRoute.path).catch(err => {console.log(err)});
			}
		},

		hasPriorityField(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		showInfoCol(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		infoColStyle(deliverable) {
			// Unused for now
            const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			if (deliverableTemplateSlug == "project-deliverable") {
				// return 'min-height:96px';
				return '';
			} else {
				return null;
			}
		},
		showDepartment(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug == "media-call";
		},
		showAltStartEndDate(deliverable) {
			const deliverableTemplateSlug = this.getDeliverableTemplateSlug(parseInt(deliverable.deliverable_template_id));
			return deliverableTemplateSlug != "media-call";
		},

		// Status toggle from the header
		toggleStatusView(expandAll) {
			if(this.isMobile()) {
				if(expandAll) {
					$('.deliverable-status-overview').hide();
					$('.deliverable-dates').css('padding-top', 0);
				} else {
					$('.deliverable-status-overview').show();
					$('.deliverable-dates').css('padding-top', '15px');
				}
			}
			this.$emit("collapseToggleUpdated", expandAll);
		},

		calculateEndDate(deliverable) {
			let latestDueDate = null;

			if (deliverable.tasks && deliverable.tasks.length > 0) {
				deliverable.tasks.forEach(x => {
					const dueDateField = x.taskFields.filter(y => y.field_key == 'due_date')[0];
					if (dueDateField && dueDateField.value && (!latestDueDate || latestDueDate < dueDateField.value)) latestDueDate = dueDateField.value;
				});
			}

			return latestDueDate;
		},

		closeVuewSelectModal() {
			this.$bvModal.hide("headerViewSelectModal");
		},

		userCanEditDeliverable() {
            return (this.userAbilities.deleteMediaCall);
        },

		deleteDeliverableClick(deliverable) {
			// deliverable.deleteClicked = true;
			if (!this.isMobile()) {
				this.showRemoveDeliverableId = deliverable.id;
				this.$bvModal.show("deleteDeliverableConfirmModal");
			} else {
				if (this.stripRemoveDeliverableId == null) {
					this.stripRemoveDeliverableId = deliverable.id;
				} else {
					this.showRemoveDeliverableId = deliverable.id;
					this.$bvModal.show("deleteDeliverableConfirmModal");
				}
			}
		},
		deleteDeliverableClickOutside(deliId) {
			let that = this;
			return () => {
				if (that.stripRemoveDeliverableId == deliId) {
					that.stripRemoveDeliverableId = null;
				}
			}
		},
		onConfirmRemoveDeliverable() {
			if (this.showRemoveDeliverableId) {
				let that = this;
				let deliverable = null;
				if (this.deliverablesArray instanceof Array) {
					deliverable = this.deliverablesArray.find(x => x.id == this.showRemoveDeliverableId);
				} else {
					for (let i of Object.keys(this.deliverablesArray)) {
						deliverable = this.deliverablesArray[i].find(x => x.id == this.showRemoveDeliverableId);
						if (deliverable != null) break;
					}
				}

				this.$store.dispatch(this.namespace + "removeDeliverable", { deliverableId:this.showRemoveDeliverableId }).then(function() {
				that.$bvModal.hide("deleteDeliverableConfirmModal");
				// TODO: removing a deliverable should only remove it from the list, not replace entire list.
				// that.$store.commit(this.namespace + 'removeMediaCallFromList', deliverableId);
				// that.$store.dispatch(that.namespace + 'countOutlets');

				that.showRemoveDeliverableId = null;

				that.$store.dispatch(that.namespace + 'fetchDeliverables').then(function() {
					toast.hide();

						that.$store.dispatch(that.namespace + 'manageUndoActivation', 'Deliverable deleted.');

					that.$store.dispatch(that.namespace + 'fetchProjectDeliverable');
				});
				});
			}
		},
		onCancelRemoveDeliverable() {
			this.showRemoveDeliverableId = null;
		},

		createCampaignClick() {
			let that = this;
			
			this.createSocialCampaign({
				title: "Social Campaign"
			}).then(() => {
				this.$nextTick(() => {
					that.$bvModal.show('editSocialCampaignModal');
				});
			});
		},
		calculateCampaignDialogSpace() {
			let target = $(".new-social-group-container");
			const offset = target.offset();
			const dh = $("html").height();
			
			this.$nextTick(() => {
				const dialog = target.find(".social-media-group-popup");
				const dialogHeight = dialog.height();

				if ((offset.top + 100 + dialogHeight) > dh) {
					// Option 1: Calculate the position for the dialog so it doesn't go over the bottom of the page.
					// const dialogTop =  dialogHeight - (dh - offset.top - 100);
					// dialog.css("top", `-${dialogTop}px`);

					// Option 2: Put the dialog on top of the title
					dialog.addClass("is-top");
				}
			});
		},
		createCampaignClose() {
			this.isCreateCampaignOpen = false;
		},
		createSeriesClick() {
			let that = this;

			this.createSocialSeries().then(() => {
				that.$bvModal.show('editSocialModal');
			});
		},
	},
	beforeUpdate() {
		if(this.activeView != '-1' && ((typeof this.activeView).toLowerCase() == "string" ? !this.activeView.startsWith('p') : true)) {
			$('.views__scroll > div').removeClass('scroll__view__btns');
			$('.update-view').removeClass('d-none');
		} else {
			$('.views__scroll > div').addClass('scroll__view__btns');
			$('.update-view').addClass('d-none');
		}
		if(!$('.deliverable-listing').hasClass('hasFilter')) {
			$('.save-view').addClass('d-none');
			$('.update-view').addClass('d-none');
			this.showUpdateViewText = false;
			$('.views__scroll > div').addClass('scroll__view__btns');
			this.showCreateNewView = false;
		} else {
			$('.save-view').removeClass('d-none');

			if(this.activeView == '-1') {
				this.showCreateNewView = true;
			} else {
				this.showCreateNewView = false;
			}
		}
		if($('.save-view').hasClass('d-none') && $('.update-view').hasClass('d-none')) {
			$('.views__scroll > div').addClass('scroll__view__btns');
		} else {
			$('.views__scroll > div').removeClass('scroll__view__btns');
		}

		this.viewModalShowCreateView = !$('.save-view').hasClass('d-none');
		this.viewModalShowUpdateView = !$('.update-view').hasClass('d-none');
	},
	mounted() {
		let that = this;
		this.$root.$on('bv::modal::hide', function(bvEvent, modalId) {
			if(modalId == 'editDeliverableModal' && that.$router.currentRoute.name == 'myWeek') {
				that.sortTasks({sortKey: false, deliverables: that.deliverablesArray, sortFields: true, namespace:that.namespace})
			}
		});
		this.$root.$on('updateListTitle', function(title) {
			that.listTitle = title;
		});
		this.setActiveView();

		this.$root.$on('hideUpdateText', function() {
			that.showUpdateViewText = false;
		});
		this.$root.$on('resetView', function() {
			that.resetView();
		});
		let tempJson3 = false;
		this.$root.$on('showUpdateViewText', function(payload) {
			if(that.$router.currentRoute.name != 'myWeek' && that.$router.currentRoute.name != 'dashboard' && that.$router.currentRoute.name != 'mediaCallPage' && that.$router.currentRoute.name != 'socialMedia') return;

			let currentFilter = payload.currentFilter
			let excludedKeys = ['myWeek'];
			let tempJson1 = currentFilter;

			if(!payload.isFilterActive) {
				that.activeView = '-1'
				that.viewBtnLabel = 'Views'
			}

			let tempJson2 = that.activeView != '-1' ? that.currentViewData : false;
			if(typeof tempJson2 == 'string') {
				tempJson2 = JSON.parse(that.currentViewData);
			}

			that.showUpdateViewText = false;
			if(tempJson2) {
				Object.entries(currentFilter).forEach(([key, value]) => {
					if(typeof tempJson2[key] != 'undefined'
						&& excludedKeys.indexOf(key) == -1) {
						if(key == 'dateRange' || key == 'dateCreatedRange' || key == 'dateCompletedRange' || key == 'datePublishRange') {
							let tempDateFlags = {
								dateRange: 'filterByDate',
								dateCreatedRange: 'filterByDateCreated',
								dateCompletedRange: 'filterByDateCompleted',
								datePublishRange: 'filterByPublishDate'
							};
							if(tempJson2[tempDateFlags[key]]) {
								let temp1StartDate = (typeof tempJson1[key].startDate != 'string') ? tempJson1[key].startDate.toISOString() : tempJson1[key].startDate,
									temp1EndDate = (typeof tempJson1[key].endDate != 'string') ? tempJson1[key].endDate.toISOString() : tempJson1[key].endDate,
									temp2StartDate = (typeof tempJson2[key].startDate != 'string') ? tempJson2[key].startDate.toISOString() : tempJson2[key].startDate,
									temp2EndDate = (typeof tempJson2[key].endDate != 'string') ? tempJson2[key].endDate.toISOString() : tempJson2[key].endDate;
								if((temp1StartDate.substr(0, 10) != temp2StartDate.substr(0, 10)) && temp1EndDate.substr(0, 10) != temp2EndDate.substr(0, 10)) {
									if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
										that.activeView = -1;
									} else {
										that.showUpdateViewText = true;
									}
									return;
								}
							}
						} else {
							if(JSON.stringify(tempJson1[key]) != JSON.stringify(tempJson2[key])) {
								if (((typeof that.activeView).toLowerCase() == "string" && that.activeView.startsWith('p')) || that.activeView == -1) {
									that.activeView = -1;
								} else {
									that.showUpdateViewText = true;
								}
								return;
							}
						}
					}
				});
			}
		});

		Echo.channel('deliverable').listen('DeliverableUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {
					if (this.allDeliverables[x].id == e.deliverable.deliverableId) {
						this.$store.commit(this.namespace + "setDeliverable", e.deliverable);
						this.$store.commit(this.namespace + "setDeliverableDetail", e.deliverable);
					}
				}
			}
		});
		Echo.channel('deliverable').listen('DeliverableContactsUpdated', (e) => {
			let userId = localStorage.getItem("userId");
				if (userId != e.user.id) {
					this.$store.commit(this.namespace + "setDeliverableContacts", {contacts:e.contacts, deliverableId: e.deliverableId});
				}
		});
		Echo.channel('task').listen('TaskUpdated', (e) => {
			let userId = localStorage.getItem("userId");
			if (userId != e.user.id) {
				let x = 0;
				let xx = 0;
				for (x = 0; x < this.allDeliverables.length; x++) {

					if (this.allDeliverables[x].id == e.deliverableId) {
						// ok, lets update the task now for that deliverable..
						for (xx = 0; xx < this.allDeliverables[x].tasks.length; xx++) {
							if (this.allDeliverables[x].tasks[xx].taskId == e.task.taskId) {
								this.$store.commit(this.namespace + "setTask", {task:e.task, deliverableId: e.deliverableId});
								}
						}
					}
				}
			}
		});

		this.$root.$on("bv::modal::hide", (bvEvent, modalId) => {
			if (modalId == "editSocialModal") {
				this.$store.state.deliverables.editSocialModal = false;
			}
		});
		this.$root.$on("bv::modal::show", (bvEvent, modalId) => {
			if (modalId == "editSocialModal") {
				this.$store.state.deliverables.editDeliverableModal = true;
			}
		});

		if(this.$router.currentRoute.path.indexOf('/social-media/') != -1) {
			let deliverableId = this.$router.currentRoute.path.split('/')[2],
				that = this;
			this.$store.dispatch(this.namespace + 'fetchSystemSettings').then(function(){
				that.$store.dispatch(that.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			});
				/*
				This works, trying sequential calls instead of interval
				let waitForSystemSettings = setInterval(function(){
					if(that.systemSettings != undefined){
						console.log("Waiting for system settings");
						that.$store.dispatch(that.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
							that.$bvModal.show('editSocialModal');
						});
						clearInterval(waitForSystemSettings);
					}
				}, 100);*/
		}

		// fetch user manage projects
		this.fetchUserManageProjects();
	},
	watch: {
		'$route': function(to, from) {
			if(to.path.indexOf('social-media/') != -1) {
				let deliverableId = to.path.split('/')[2],
					that = this;
				this.$store.dispatch(this.namespace + 'getDeliverableDetail', {deliverableId: deliverableId}).then(function() {
					that.$bvModal.show('editSocialModal');
				});
			}
		},
		'viewBtnLabel': function(oldVal, newVal) {
			console.log(oldVal);
		}
	}
};
</script>
